import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@/components';
import { CartProvider } from '@/contexts/cartContext';
import { registerServiceWorker } from '@/pwa/registerServiceWorker';
import { router } from './routes/router.tsx';

import './i18n/config';
import './index.css';

// Create query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

registerServiceWorker();

createRoot(rootElement).render(
  <StrictMode>
    <ThemeProvider>
      <CartProvider>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </CartProvider>
    </ThemeProvider>
  </StrictMode>
);
